const features = [
  {
    title: '海量原创内容',
    desc: '海角网千万原创作品每日更新，覆盖视频、图文、音频等多元媒体形式，满足不同用户的浏览偏好。',
    icon: 'ri-database-2-line',
  },
  {
    title: '活跃社区生态',
    desc: '海角社区拥有百万级活跃用户，在论坛和评论区形成高质量的互动氛围，让每位成员都有归属感。',
    icon: 'ri-user-community-line',
  },
  {
    title: '稳定访问体验',
    desc: '海角官网入口多重保障，海角网址智能切换，确保用户随时随地通过海角在线顺畅访问平台。',
    icon: 'ri-shield-flash-line',
  },
  {
    title: '持续创新迭代',
    desc: '海角社不断推出新功能和新活动，从创作者工具到社区玩法，持续优化海角网的用户体验。',
    icon: 'ri-rocket-line',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            为什么选择海角网
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature) => (
            <article
              key={feature.title}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 text-center group hover:border-primary-200 transition-colors duration-200"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto rounded-2xl bg-gradient-to-br from-primary-100 to-accent-100 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-900">
                {feature.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}